import { render, staticRenderFns } from "./PsAdministrationTransactions.vue?vue&type=template&id=0b8b8201&scoped=true&"
import script from "./PsAdministrationTransactions.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationTransactions.vue?vue&type=style&index=0&id=0b8b8201&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b8201",
  null
  
)

export default component.exports